import { render, staticRenderFns } from "./Jordan.vue?vue&type=template&id=7c3e127a&scoped=true&"
import script from "./Jordan.vue?vue&type=script&lang=js&"
export * from "./Jordan.vue?vue&type=script&lang=js&"
import style0 from "./Jordan.vue?vue&type=style&index=0&id=7c3e127a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e127a",
  null
  
)

export default component.exports